import React from 'react';
import classnames from 'classnames';
import CheckCircle from '@mui/icons-material/CheckCircle';

import { Typo } from 'uikit/content';

import styles from '../styles/initiativeWizardHeader.module.scss';

const InitiativeWizardHeader = ({
  currentIndex,
  isNumbered,
  onNavigateButtonClick,
  pages,
}) => (
  <nav className={classnames(styles.element, isNumbered && styles.isNumbered)}>
    <ol className={styles.list}>
      {pages.map(({ isComplete, title }, index) => (
        <li className={styles.linkContainer} key={title}>
          <a
            className={classnames(styles.link, {
              [styles.isActive]: index === currentIndex,
              [styles.isComplete]: isComplete,
            })}
            href={`#${index}`}
            onClick={() => onNavigateButtonClick(index)}
          >
            {isComplete && <CheckCircle className={styles.icon} sx={{ height: 12, width: 12 }} />}
            <Typo
              className={styles.title}
              element="span"
              modifier="uppercase"
              variant="s01"
              weight="medium"
            >
              {title}
            </Typo>
          </a>
        </li>
      ))}
    </ol>
  </nav>
);

export default React.memo(InitiativeWizardHeader);
